import { render, staticRenderFns } from "./EditorAssignmentsTable.vue?vue&type=template&id=0da3bfa1&scoped=true&"
import script from "./EditorAssignmentsTable.vue?vue&type=script&lang=js&"
export * from "./EditorAssignmentsTable.vue?vue&type=script&lang=js&"
import style0 from "./EditorAssignmentsTable.vue?vue&type=style&index=0&id=0da3bfa1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da3bfa1",
  null
  
)

export default component.exports